import AppShell from './app/AppShell';
import { SessionProvider } from './app/session';

export default function App() {
  return (
    <SessionProvider>
      <AppShell />
    </SessionProvider>
  );
}
